module.exports = __webpack_public_path__ + "img/bgpattern.cdbe30e1.png";